import {convertToUrlParams} from 'utils'
import baseApi, {provideTag} from './baseApi'

const metersReadingApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getMeterReadings: build.query({
            query: (query) => {
                const params = convertToUrlParams(query)

                return {
                    url: `metersReading${params}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: () => provideTag('MeterReading'),
        }),
        getMeterReading: build.query({
            query: (id) => {
                return {
                    url: `metersReading/${id}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: (result) => provideTag('MeterReading', result),
        }),
        deleteMeterReading: build.mutation({
            query: (id) => {
                return {
                    url: `metersReading/${id}`,
                    method: 'DELETE',
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['MeterReading'],
        }),
        createMeterReading: build.mutation({
            query: (data) => {
                return {
                    url: `metersReading`,
                    method: 'POST',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['MeterReading'],
        }),
        editMeterReading: build.mutation({
            query: (data) => {
                return {
                    url: `metersReading/${data._id}`,
                    method: 'PUT',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['MeterReading'],
        }),
        updateMeterReadingValue: build.mutation({
            query: (id) => ({
                url: `metersReading/update-value/${id}`,
                method: 'PUT',
            }),
            invalidatesTags: ['MeterReading'],
        }),
        getMeterReadingDaily: build.query({
            query: (query) => {
                const params = convertToUrlParams(query)
                return {
                    url: `metersReading/daily${params}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: () => provideTag('DailyMeterReading'),
        }),
        getMeterReadingTrend: build.query({
            query: (query) => {
                const params = convertToUrlParams(query)
                return {
                    url: `metersReading/dashboard/trend${params}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: () => provideTag('DailyMeterReading'),
        }),
        getMeterReadingDashboard: build.query({
            query: (query) => {
                const params = convertToUrlParams(query)
                return {
                    url: `metersReading/dashboard${params}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: () => provideTag('DailyMeterReading'),
        }),
    }),
    overrideExisting: false,
})

export default metersReadingApi

export const {
    useGetMeterReadingsQuery,
    useGetMeterReadingQuery,
    useDeleteMeterReadingMutation,
    useCreateMeterReadingMutation,
    useEditMeterReadingMutation,
    useUpdateMeterReadingValueMutation,
    useGetMeterReadingDailyQuery,
    useGetMeterReadingDashboardQuery,
    useGetMeterReadingTrendQuery,
} = metersReadingApi
